import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import TextInput from '../../../../lib/TextField';
import { RootStateType } from '../../../../redux-store/reducers';
import { MINOR_MAJOR, panRegex } from '../../../../utils/constants';
import FatcaCheck from '../../../common/FatcaCheck';
import {KYCCheck} from '../../../common/KYCCheck';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
const { dashboard, common } = en;
const initMessage: { error: boolean; message: string } = { error: false, message: '' };

function MinorStatusPan(props: any) {
    const [pan, setPan] = useState<string>('');
    const { targetFunds } = props.location.state || {};
    const [panError, setPanError] = useState<{ error: boolean; message: string }>(initMessage);
    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
    });
    const handleSubmit = async () => {
        if (pan === props.pan)
            return setPanError({ error: true, message: common.errors.pan.matchError });
        if (pan && pan.length > 0) {
            if (pan.toUpperCase().match(panRegex)) {
                // let response = await props.sendPhoneOTP({ mobile: `+91${mobile}` });
                // props.history.push('update-pan-otp', {
                //     userInfo: pan,
                //     body: {otp:"123456", reqId:"2323", otpRef:"123331122"},
                //     isEmail: false,
                // });
                props.history.replace('minor-status-list', {
                    targetFunds,
                    newPan: pan.toUpperCase(),
                });
            } else {
                setPanError({ error: true, message: common.errors.pan.individualPan });
            }
        } else {
            setPanError({ error: true, message: common.errors.pan.required });
        }
    };
    const [callPanSeed, setCallPanSeed] = useState(false);
    const resetTrigger = () => {
        setCallPanSeed(false);
    }
    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                foliosArray={targetFunds}
                callBackFn={handleSubmit}
                trxnType={NFT_TRXN_TYPE_MAP.minorToMajor}
                triggerCheck={callPanSeed}
                resetTrigger={resetTrigger}
                goBack={true}
            />
            <KYCCheck
                allowRegistration={{ isin: targetFunds[0]?.isin, amc: targetFunds[0]?.amc }}
            />
            <FatcaCheck rtaName={targetFunds[0]?.rtaName} />
            <ActionHeader header={dashboard.MinorStatus.MinorStatusHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-email-img.png" alt="icon" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.MinorStatus.EnterPan.subHeading}
                            <span>{dashboard.MinorStatus.EnterPan.subHeadingSpan}</span>
                        </h3>
                        <p>{dashboard.MinorStatus.EnterPan.subHeadingInfo}</p>
                        <TextInput
                            variant="outlined"
                            label={dashboard.MinorStatus.EnterPan.enter}
                            onChange={({ target: { value } }) => {
                                setPan(value);
                                setPanError(initMessage);
                            }}
                            value={pan.toUpperCase()}
                            error={panError.error}
                            helperText={panError.message}
                        />
                    </div>
                    <FaqLink section={MINOR_MAJOR} history={props.history} />
                    <div className="curved-bg-content-inner-bottom">
                        <Button className="customBtn" onClick={()=> setCallPanSeed(true)} disabled={!pan}>
                            {dashboard.MinorStatus.ReviewDetails.buttonText}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default connect(
    ({ authReducer }: RootStateType) => ({ ...authReducer }),
    null,
)(MinorStatusPan);
